import { Controller } from "@hotwired/stimulus";

import { reloadFrame } from "../lib/frames.js";
import { patch, post } from "../lib/http.js";
import { showToast } from "../lib/toast.js";

/**
 * Модалка «мой прогресс» — одна на всю полку.
 *
 * Открывается событием shelf-book:progress от карточки. Процент и полоса
 * пересчитываются прямо при вводе: в макете они и есть главное содержимое
 * окна. Прежняя версия собирала разметку строкой и вычитывала страницы
 * из текста карточки регулярным выражением.
 */
export default class extends Controller {
  static targets = ["form", "book", "page", "total", "percent", "bar", "note"];
  static values = { frame: { type: String, default: "shelf-list" } };

  open(event) {
    this.bookshelfId = event.detail.bookshelfId;
    this.bookTarget.textContent = event.detail.title || "";
    this.formTarget.reset();
    this.fill(event.detail);
    this.element.showModal();
    this.pageTarget.focus();
  }

  close() {
    this.element.close();
    this.bookshelfId = null;
  }

  /** Страницы приходят вместе с событием: они уже нарисованы на карточке. */
  fill(detail) {
    if (detail.page != null) this.pageTarget.value = detail.page;
    if (detail.total != null) this.totalTarget.value = detail.total;
    this.preview();
  }

  /** Перерисовывает процент и полосу под введёнными числами. */
  preview() {
    const page = Number(this.pageTarget.value) || 0;
    const total = Number(this.totalTarget.value) || 0;
    const percent = total > 0 ? Math.min(100, Math.max(0, Math.round((page / total) * 100))) : 0;

    this.percentTarget.innerHTML = `${percent}<span>%</span>`;
    this.barTarget.style.setProperty("--progress", `${percent}%`);
    this.noteTarget.textContent = total ? `${page} из ${total} страниц` : "Укажите объём книги";
  }

  /** Сохраняет объём книги и прочитанную страницу. */
  async submit(event) {
    event.preventDefault();

    const page = Number(this.pageTarget.value);
    const total = Number(this.totalTarget.value);

    if (!total || total < 1) {
      showToast("Укажите общее количество страниц");
      return;
    }
    if (page < 0 || page > total) {
      showToast("Прочитанных страниц не может быть больше, чем всего");
      return;
    }

    try {
      // Объём книги живёт в записи полки, прогресс — отдельной записью.
      await patch(`/api/shelf/books/${this.bookshelfId}`, { pages: total });
      await post(`/api/shelf/${this.bookshelfId}/progress`, { page });
    } catch (error) {
      showToast(error.message);
      return;
    }

    showToast("Прогресс обновлён", "success");
    this.close();
    reloadFrame(this.frameValue);
  }
}
